import { Pipe, PipeTransform } from '@angular/core';
import { IMedia } from '../_interfaces/media.interface';

@Pipe({
  name: 'twicpicUrl',
  standalone: true
})
export class SdTwicpicUrlPipe implements PipeTransform {
  transform(value: IMedia | undefined): string {
    return this.getUrl(value);
  }

  private getUrl(media: IMedia): string {
    if (!media?.urlTwicPic) {
      return '';
    }
    const baseUrl = `https://${media?.twicPicsDomain}/`;
    const previewUrl = media?.urlTwicPic?.replace('image:/', '');
    const transform = 'twic=v1/output=preview';

    return `${baseUrl}${previewUrl}${previewUrl.includes('?') ? '&' : '?'}${transform}`;
  }
}
